import React from 'react';

function NotFoundPage() {
  return (
    <div className='flex h-screen w-full flex-col items-center justify-center text-gray-800'>
      <div className='mb-10 text-4xl font-bold'>404 Not Found</div>
    </div>
  );
}

export default NotFoundPage;
